var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('router-view'),_c('div',{staticClass:"button-view no-print",class:_vm.scrolled ? 'mover' : null},[_c('botao-favoritos'),(_vm.getCanal)?_c('botao-tabela-de-precos'):_vm._e()],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }